/**
 * [Pure] Returns IE version or 0.
 */
export function isIe(): number {
    const ua = window.navigator.userAgent;
    if (ua.indexOf("MSIE ") > 0) return versionFinder(ua, "MSIE ");     // IE 10 or older, return version number
    if (ua.indexOf("Trident/") > 0) return versionFinder(ua, "rv:");    // IE 11, return version number
    if (ua.indexOf("Edge/") > 0) return versionFinder(ua, "Edge/");     // Edge, return version number
    return 0;                                                           // Other browsers, return 0.
}

function versionFinder(ua: any, agent: string): number {
    const index = ua.indexOf(agent);                                                        // Get index of browser in user agent.
    const num = parseInt(ua.substring(index + agent.length, ua.indexOf(".", index)), 10);   // Get version number of browser.
    return num || 0;                                                                        // Return version number or 0.
}
